module.exports = __webpack_public_path__ + "static/media/guildford.27b10ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/guildford.png
// module id = 550
// module chunks = 0